/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {AbstractResourceService} from '@irian-ro/abstract-resource';
import {EnvironmentService} from "@irian-ro/util-environment";
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CofaceCountriesResourceService extends AbstractResourceService<any, any, any, any> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('cofaceCountriesUrl'),
      undefined,
      undefined
    );
  }

  getCountries(): Observable<any[]> {
    return this.httpClient?.get(`${this.url}/list`).pipe(this.mapToListOfObjects());
  }

}

